export var adminSignIn = '/sign_in';
export var adminLogout = '/logout';
export var adminMfa = '/admin/compass/two_factor_authentication/';
export var kareoHomepage = 'https://app.kareo.com/login-ui/#/login';
export var compassForbidden = '/admin/compass/403';
